import React from "react";
import { Button, ColorTokens, useColorTokens } from "@tvg/design-system";
import { useNavigate } from "react-router";
import { Paragraph } from "@tvg/design-system/web";
import { Wrapper, Header, ListContainer } from "./styled-components";
import DesktopView from "../DesktopView";
import MobileView from "../MobileView";
import { Props } from "./types";
import { getDeviceStyleConfig } from "../../utils";
import { QA_LABEL } from "../../qaLabels";

const TopPoolsWrapper = ({
  pools = [],
  isDesktop,
  title,
  onPoolClick,
  onTouchStart,
  onTouchMove,
  qaLabel
}: Props) => {
  const navigate = useNavigate();
  const { background } = useColorTokens() as ColorTokens;

  const style = getDeviceStyleConfig(isDesktop);

  const handleSeeAllClick = () => {
    navigate("/tracks", { state: { isFromTopPools: true } });
  };

  const sharedProps = {
    style,
    onPoolClick,
    pools
  };

  return (
    <Wrapper
      data-qa-label={qaLabel}
      borderRadius={style.borderRadius}
      backgroundColor={background.surface}
    >
      {isDesktop && (
        <Header
          height={style.header.height}
          data-qa-label={QA_LABEL.header.container}
        >
          <Paragraph
            qaLabel={QA_LABEL.header.title}
            fontSize={18}
            fontFamily="bold"
            color="--fd-colors-content-strong"
          >
            {title}
          </Paragraph>
          <Button
            qaLabel={QA_LABEL.header.seeAll}
            onPress={handleSeeAllClick}
            variant="tertiary"
            size="m"
          >
            See all
          </Button>
        </Header>
      )}
      <ListContainer
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        flexDirection={style.body.direction}
        gap={style.body.gap}
        padding={style.body.padding}
        data-qa-label={QA_LABEL.body.container}
      >
        {isDesktop ? (
          <DesktopView {...sharedProps} />
        ) : (
          <MobileView {...sharedProps} />
        )}
      </ListContainer>
    </Wrapper>
  );
};

export default TopPoolsWrapper;
